import React from "react";
import { Wizard, Step } from "@activecollab/components";
import PropTypes from "prop-types";
import AddPaymentMethodFirstStep from "~/components/Subscription/AddPaymentMethodSteps/AddPaymentMethodFirstStep";
import AddPaymentMethodSecondStep from "~/components/Subscription/AddPaymentMethodSteps/AddPaymentMethodSecondStep";

const AddPaymentMethodProcess = ({ open, onClose, onSubmit }) => {
  return (
    <Wizard
      title="Add Payment Method"
      open={open}
      onClose={onClose}
      disableCloseOnEsc
    >
      <Step
        skip={false}
        subtitle="Billing Address"
        shouldRenderNextButton={false}
      >
        <AddPaymentMethodFirstStep />
      </Step>
      <Step
        subtitle="Credit Card"
        shouldRenderNextButton={false}
      >
        <AddPaymentMethodSecondStep handleSubmit={onSubmit} />
      </Step>
    </Wizard>
  );
};

AddPaymentMethodProcess.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default AddPaymentMethodProcess;
